const marketing = {
  meta: {
    title: "TGReposter — منصة ذكية لإدارة محتوى Telegram",
    description: "اجمع محتوى Telegram وصفّه وحسّنه وراجعه وانشره من مساحة عمل خاصة واحدة.",
  },
  accessibility: {
    home: "الصفحة الرئيسية لـ TGReposter",
    mainNavigation: "التنقل الرئيسي",
    mobileNavigation: "التنقل على الهاتف",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    flowImage: "تدفق تجريدي للمحتوى عبر معالجة الذكاء الاصطناعي إلى وجهات Telegram",
  },
  nav: {
    salesPlan: "خطط الأسعار",
    workflow: "كيف يعمل",
    capabilities: "الإمكانات",
    security: "الأمان",
    demo: "اطلب عرضاً تجريبياً",
    dashboard: "فتح لوحة التحكم",
  },
  hero: {
    badge: "عمليات محتوى Telegram مدعومة بالذكاء الاصطناعي",
    title: "حوّل ضوضاء Telegram إلى إشارة نشر واضحة.",
    body: "راقب القنوات المهمة، وحسّن المنشورات بالذكاء الاصطناعي، وانشر المحتوى المعتمد إلى جميع وجهات Telegram من مساحة عمل خاصة واحدة.",
    primary: "اطلب وصولاً تجريبياً",
    secondary: "شاهد سير العمل",
    humanApproved: "النشر بعد موافقة بشرية",
    isolated: "مساحات عمل معزولة لكل مستخدم",
    stack: "مصمم ليتكامل مع تقنياتك",
  },
  workflow: {
    eyebrow: "سير عمل متكامل",
    title: "من قناة المصدر إلى المنشور المنشور.",
    body: "يجمع TGReposter التحصيل والتصفية والتحسين بالذكاء الاصطناعي والمراجعة التحريرية والتوزيع في مسار واحد قابل للتتبع، مع إبقاء قرار النشر بيد الإنسان.",
    collect: { title: "اجمع", copy: "راقب قنوات Telegram العامة التي تهمك." },
    filter: { title: "صفِّ", copy: "احتفظ بالمنشورات المفيدة وتخلّص من الضوضاء وفق قواعدك الخاصة." },
    refine: { title: "حسّن", copy: "أعد الصياغة ولخّص وترجم وأنشئ الوسوم باستخدام الذكاء الاصطناعي." },
    publish: { title: "انشر", copy: "راجع مرة واحدة ثم أرسل إلى وجهة واحدة أو عدة وجهات في Telegram." },
  },
  inbox: {
    title: "صندوق المحتوى",
    status: "جاهز للمراجعة",
    matched: "12 نتيجة",
    now: "الآن",
    first: { title: "تحديث في بنية الذكاء الاصطناعي", action: "أخبار" },
    second: { title: "إطلاق نموذج مفتوح المصدر", action: "ترجمة" },
    third: { title: "تقرير منظومة Telegram", action: "ملخص" },
  },
  capabilities: {
    eyebrow: "غرفة التحكم التحريرية",
    title: "الأتمتة حيث تفيد. والحكم البشري حيث يهم.",
    body: "استخدم الذكاء الاصطناعي لتعمل أسرع من دون أن تفقد التحكم في أسلوبك. يبقى كل منشور قابلاً للتحرير والمراجعة قبل وصوله إلى جمهورك.",
    items: {
      privateInbox: "صندوق محتوى خاص لكل مستخدم",
      aiProviders: "دعم Gemini وOpenRouter",
      humanReview: "مراجعة بشرية قبل النشر",
      multiDestination: "إرسال متوازٍ إلى عدة وجهات",
      campaigns: "حملات للقنوات والمجموعات والمجموعات الفائقة",
      roles: "صلاحيات فريق قائمة على الأدوار",
    },
  },
  cards: {
    curation: {
      eyebrow: "تنسيق المحتوى",
      title: "أنشئ موجزاً مركزاً من القنوات التي تراقبها.",
      body: "اجمع المنشورات المطابقة، واحذف الترويج غير المرغوب فيه، وحسّن الصياغة، وانشر فقط ما يستحق الاهتمام.",
    },
    campaign: {
      eyebrow: "توزيع الحملات",
      title: "انقل رسالة واحدة معتمدة عبر شبكة Telegram الخاصة بك.",
      body: "نسّق الإرسال إلى القنوات والمجموعات والمجموعات الفائقة مع إبقاء نتيجة كل وجهة مستقلة.",
    },
  },
  security: {
    eyebrow: "خصوصية مدمجة في التصميم",
    title: "مساحة عملك تخصك وحدك.",
    body: "تُعزل المصادر والفلاتر ومنشورات الصندوق والوجهات والحملات وتفضيلات الذكاء الاصطناعي لكل مستخدم. تبقى بيانات الاعتماد الحساسة في الخادم وتحميها المصادقة والصلاحيات.",
  },
  salesPlan: {
    "eyebrow": "خطط المبيعات · أسعار مخططة",
    "title": "منصة واحدة. خطة تناسب كل حجم من عمليات Telegram.",
    "intro": "ابدأ بتنظيم المحتوى ثم توسّع إلى النشر متعدد القنوات والحملات والعمل الجماعي.",
    "billingLabel": "دورة الفوترة",
    "periods": {
      "monthly": "شهرياً",
      "annual": "سنوياً"
    },
    "notice": "معاينة للأسعار المعتمدة والحدود المخطط لها. الاشتراكات والدفع وشراء وحدات الذكاء الاصطناعي الإضافية غير متاحة بعد. اطلب عرضاً تجريبياً لمناقشة الخطة.",
    "popular": "الأكثر شيوعاً",
    "custom": "مخصص",
    "perMonth": "/ شهر",
    "enterpriseBilling": "عقد مخصص",
    "freeForever": "مجاني دائماً",
    "monthlyCharge": "تُدفع شهرياً",
    "annualCharge": "تُدفع {{price}} سنوياً",
    "plannedLimits": "الحدود المخطط لها",
    "metrics": {
      "users": "أعضاء الفريق",
      "sources": "مصادر المراقبة",
      "destinations": "وجهات النشر",
      "campaigns": "الحملات النشطة",
      "ai": "وحدات AI / شهر",
      "history": "سجل النشر"
    },
    "history": {
      "days7": "٧ أيام",
      "days90": "٩٠ يوماً",
      "year1": "سنة",
      "year2": "سنتان",
      "year3": "٣ سنوات",
      "custom": "مخصص"
    },
    "request": "طلب الوصول",
    "contact": "تواصل مع الفريق",
    "discussPlan": "مناقشة خطة {{plan}}",
    "annualSavings": "وفّر حتى ١٧٪ بالدفع السنوي، ما يعادل شهرين تقريباً مجاناً.",
    "plans": {
      "free": {
        "name": "Free",
        "audience": "للتجربة",
        "description": "جرّب سير عمل المحتوى الأساسي مع عدد قليل من القنوات."
      },
      "creator": {
        "name": "Creator",
        "audience": "لصنّاع المحتوى",
        "description": "وفّر وقت تنسيق المحتوى ونشره على قنواتك."
      },
      "professional": {
        "name": "Professional",
        "audience": "للقنوات المتعددة",
        "description": "أدِر المراقبة والنشر والترويج من مساحة واحدة."
      },
      "business": {
        "name": "Business",
        "audience": "للفرق الإعلامية",
        "description": "خطّط لعمليات محتوى أكبر بمشاركة فريقك."
      },
      "agency": {
        "name": "Agency",
        "audience": "لشبكات القنوات",
        "description": "نسّق شبكات النشر الكبيرة ومحافظ الحملات."
      },
      "enterprise": {
        "name": "Enterprise",
        "audience": "للمؤسسات",
        "description": "ناقش السعة والحوكمة والتكاملات والدعم المخصص."
      }
    },
    "topUps": {
      "eyebrow": "وحدات AI إضافية",
      "title": "أضف وحدات AI حسب الحاجة.",
      "description": "حزم AI المخطط لها تُكمل الحصة الشهرية المضمنة في كل اشتراك.",
      "units": "{{units}} وحدة AI",
      "note": "تمثل وحدات AI تكلفة استخدام النموذج، لا عدداً ثابتاً من العمليات. شراء الحزم والاحتساب التجاري غير متاحين بعد.",
      "packs": {
        "mini": "AI Mini",
        "plus": "AI Plus",
        "pro": "AI Pro",
        "max": "AI Max"
      }
    }
  },
  cta: {
    eyebrow: "شاهده ضمن سير عملك",
    title: "اطلب وصولاً تجريبياً.",
    body: "أخبرنا قليلاً عن سير عملك على Telegram. سنراجع حالة الاستخدام ونرسل لك تفاصيل الوصول التجريبي المناسبة.",
    button: "اطلب عرضاً تجريبياً",
    points: {
      tailored: "عرض مخصص لسير عملك في تنسيق المحتوى أو الحملات أو كليهما",
      private: "يتعامل فريق TGReposter مع طلبك بخصوصية",
      human: "لا يوجد تسجيل تلقائي — تتم مراجعة الطلب قبل منح الوصول التجريبي",
    },
  },
  demoForm: {
    eyebrow: "الوصول التجريبي",
    title: "أخبرنا أين يمكن لـ TGReposter مساعدتك.",
    fullName: "الاسم",
    fullNamePlaceholder: "سارة أحمد",
    email: "البريد الإلكتروني",
    emailPlaceholder: "sara@company.com",
    company: "الشركة / الفريق (اختياري)",
    companyPlaceholder: "اسم المؤسسة",
    telegram: "اسم مستخدم Telegram (اختياري)",
    telegramPlaceholder: "@username",
    useCase: "كيف تريد استخدام TGReposter؟",
    useCases: {
      curation: "تنسيق المحتوى وإعادة النشر",
      campaigns: "حملات الترويج",
      both: "تنسيق المحتوى والحملات معاً",
      other: "استخدام آخر",
    },
    message: "ما الذي تريد رؤيته في العرض؟ (اختياري)",
    messagePlaceholder: "أخبرنا عن قنواتك أو سير عملك أو المشكلة التي تريد حلها.",
    submit: "اطلب وصولاً تجريبياً",
    submitting: "جارٍ إرسال الطلب…",
    privacy: "سنستخدم هذه البيانات فقط لمراجعة طلب العرض والتواصل معك بشأن TGReposter.",
    successTitle: "تم استلام الطلب.",
    successBody: "شكراً لك. سنراجع حالة الاستخدام ونتواصل معك بالخطوة التالية للحصول على الوصول التجريبي.",
    submitAnother: "إرسال طلب آخر",
    error: "تعذر إرسال الطلب. تحقق من الاتصال وحاول مرة أخرى.",
  },
  footer: {
    salesPlan: "خطط الأسعار",
    workflow: "سير العمل",
    capabilities: "الإمكانات",
    security: "الأمان",
    demo: "اطلب عرضاً تجريبياً",
    dashboard: "لوحة التحكم",
  },
} as const;

export default marketing;
